import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';
import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';
import {useDidMountEffect} from 'shells/utils/hooks/use-did-mount-effect';

import styles from './advanced-options.module.css';

const BUFFER_OPTIONS = [
    {label: '5 minutes', value: 5},
    {label: '10 minutes', value: 10},
    {label: '15 minutes', value: 15},
    {label: '20 minutes', value: 20},
    {label: '25 minutes', value: 25},
    {label: '30 minutes', value: 30},
    {label: '35 minutes', value: 35},
    {label: '40 minutes', value: 40},
    {label: '45 minutes', value: 45},
    {label: '50 minutes', value: 50},
    {label: '55 minutes', value: 55},
    {label: '60 minutes', value: 60},
];

const DEFAULT_BUFFER_MINS = 15;

type Props = {
    bufferBeforeMins: number | null | undefined;
    bufferAfterMins: number | null | undefined;
    onSave: (
        bufferBeforeMins?: number | null | undefined,
        bufferAfterMins?: number | null | undefined
    ) => void;
    setSavingToastKey: (arg1: string) => void;
};

export function BufferTime(props: Props) {
    const {setSavingToastKey, onSave} = props;
    const [hasBufferBefore, setHasBufferBefore] = React.useState<boolean>(
        Boolean(props.bufferBeforeMins)
    );
    const [bufferBeforeMins, setBufferBeforeMins] = React.useState<number | null | undefined>(
        props.bufferBeforeMins || DEFAULT_BUFFER_MINS
    );
    const [hasBufferAfter, setHasBufferAfter] = React.useState<boolean>(
        Boolean(props.bufferAfterMins)
    );
    const [bufferAfterMins, setBufferAfterMins] = React.useState<number | null | undefined>(
        props.bufferAfterMins || DEFAULT_BUFFER_MINS
    );

    useDidMountEffect(() => {
        const before = hasBufferBefore ? bufferBeforeMins : null;
        const after = hasBufferAfter ? bufferAfterMins : null;

        setSavingToastKey('buffer');
        onSave(before, after);
    }, [hasBufferBefore, hasBufferAfter, bufferBeforeMins, bufferAfterMins]);

    return (
        <>
            <div className={styles['buffer-row']}>
                <div className={styles.checkbox}>
                    <Checkbox
                        label='Buffer before'
                        checked={hasBufferBefore}
                        onChange={() => {
                            if (!hasBufferBefore && !bufferBeforeMins) {
                                setBufferBeforeMins(DEFAULT_BUFFER_MINS);
                            }
                            setHasBufferBefore(!hasBufferBefore);
                        }}
                    />
                </div>
                <div
                    className={
                        hasBufferBefore
                            ? styles['buffer-time-select']
                            : styles['buffer-time-select--disabled']
                    }
                >
                    <SelectPickerGeneric
                        placeholder='Select'
                        isDisabled={!hasBufferBefore}
                        options={BUFFER_OPTIONS}
                        value={BUFFER_OPTIONS.find((option) => option.value === bufferBeforeMins)}
                        // @ts-expect-error
                        onChange={(option) => {
                            setBufferBeforeMins(option.value);
                        }}
                    />
                </div>
            </div>
            <div className={styles['buffer-row']}>
                <div className={styles.checkbox}>
                    <Checkbox
                        label='Buffer after'
                        checked={hasBufferAfter}
                        onChange={() => {
                            if (!hasBufferAfter && !bufferAfterMins) {
                                setBufferAfterMins(DEFAULT_BUFFER_MINS);
                            }
                            setHasBufferAfter(!hasBufferAfter);
                        }}
                    />
                </div>
                <div
                    className={
                        hasBufferAfter
                            ? styles['buffer-time-select']
                            : styles['buffer-time-select--disabled']
                    }
                >
                    <SelectPickerGeneric
                        placeholder='Select'
                        isDisabled={!hasBufferAfter}
                        options={BUFFER_OPTIONS}
                        value={BUFFER_OPTIONS.find((option) => option.value === bufferAfterMins)}
                        // @ts-expect-error
                        onChange={(option) => {
                            setBufferAfterMins(option.value);
                        }}
                    />
                </div>
            </div>
        </>
    );
}
